
//轨迹漫游类
var matrix4 = new Cesium.Matrix4();
var matrix3Scratch = new Cesium.Matrix3();
var positionScratch = new Cesium.Cartesian3();
var orientationScratch = new Cesium.Quaternion();
var matrix4Scratch = new Cesium.Matrix4();

class PathAnimation {

    constructor(options) {
        this.viewer = options.viewer || viewer;
        //参考系
        this._fixedFrameTransform = Cesium.defaultValue(options.fixedFrameTransform, Cesium.Transforms.eastNorthUpToFixedFrame);
        this.entity = options.entity; //漫游实体
        this.endBack = options.endBack; //完成回调
        this.delay = options.delay || 0; //完成回调
        this.speed = options.speed || 30;// 漫游速度（km/h）30km/h
        this.multiple = options.multiple; //倍速
        this.positions = options.positions; //漫游路径
        this.speed_m = options.speed * 0.2777777777777778; //漫游速度-米每秒
        this.positionsArc = this.chack(options.positions); //处理一下
        //this.allTime = this.positionsArc.length; //总时间=点数*每秒（即每秒一个点位）
        this.addHeight = options.addHeight || 0;
        this.height = options.height || 0; //漫游高度
        this.shadingType = options.shadingType; //投影动画
        this.cameraType = options.cameraType; //飞行模式
        this.surface = options.surface; //飞行模式
        this.cycle = options.cycle; //是否循环
        if (!this.surface && this.height > 0 && this.addHeight <= 0) {
            this.positionsArc = this.setPositionsHeight(this.positionsArc, this.height);
        }
        if (!this.surface && this.addHeight > 0 && this.height <= 0) {
            this.positionsArc = this.addPositionsHeight(this.positionsArc, this.addHeight);
        }

        this.animationAllTime = options.sumTime;
        if (this.animationAllTime && this.animationAllTime > 0) {
            var l = this.getLength(this.positionsArc);
            this.speed_m = l / this.animationAllTime; //m/s
            this.speed_m = this.speed_m < 0.2 ? 0.2 : this.speed_m;

            console.log(this.animationAllTime);
            console.log(l);
            console.log(this.speed_m);
        }
        // if (!this.surface && this.height > 0 && this.addHeight > 0) {
        //     this.positionsArc = this.setPositionsHeight(this.positionsArc, this.height, true);
        // }
        // if (this.surface) {
        //     this.positionsArc = this.setPositionsHeight(this.positionsArc, 0, false);
        // }
    }

    /**
    * 在坐标基础海拔上增加指定的海拔高度值
    * @param {Array} positions Cartesian3类型的数组
    * @param {Number} height 高度值
    * @return {Array} Cartesian3类型的数组
    */
    addPositionsHeight(positions, addHeight) {
        addHeight = Number(addHeight) || 0;

        if (isNaN(addHeight) || addHeight == 0) return positions;

        if (positions instanceof Array) {
            var arr = [];
            for (var i = 0, len = positions.length; i < len; i++) {
                var car = Cesium.Cartographic.fromCartesian(positions[i]);
                var point = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, car.height + addHeight);
                arr.push(point);
            }
            return arr;
        } else {
            var car = Cesium.Cartographic.fromCartesian(positions);
            return Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, car.height + addHeight);
        }
    }

    setPositionsHeight(positions, height) {
        height = Number(height) || 0;

        if (positions instanceof Array) {
            var arr = [];
            for (var i = 0, len = positions.length; i < len; i++) {
                var car = Cesium.Cartographic.fromCartesian(positions[i]);
                var point = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
                arr.push(point);
            }
            return arr;
        } else {
            var car = Cesium.Cartographic.fromCartesian(positions);
            return Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
        }
    }

    /**
     * 设置坐标中海拔高度为指定的高度值
     * @param {Array} positions Cartesian3类型的数组
     * @param {Number} height 高度值
     * @return {Array} Cartesian3类型的数组
     */
    setPositionsHeightFixed(positions, height, isFixed) {
        height = Number(height) || 0;

        if (positions instanceof Array) {
            var arr = [];
            for (var i = 0, len = positions.length; i < len; i++) {
                var car = Cesium.Cartographic.fromCartesian(positions[i]);
                var heightTerrain = this.viewer.scene.globe.getHeight(car) + 0.2; //多加0.2M
                var sumHeight = isFixed ? height : heightTerrain + height;
                var point = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, sumHeight);
                arr.push(point);
            }
            return arr;
        } else {
            var car = Cesium.Cartographic.fromCartesian(positions);
            return Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
        }
    }

    chack(positions) {
        if (positions.length == 2) {
            var mid = new Cesium.Cartesian3(0, 0, 0)
            Cesium.Cartesian3.midpoint(positions[0], positions[1], mid);
            positions.splice(1, 0, mid);
        }
        var res = this.removeDuplicate(positions);
        return res;
    }

    //去除相邻重复点
    removeDuplicate(positions) {
        if (positions.length < 2) {
            return positions;
        }
        let res = [];
        let j = 0;
        res.push(positions[0]);
        for (let i = 1; i < positions.length; i++) {
            if (res[j].x == positions[i].x && res[j].y == positions[i].y && res[j].z == positions[i].z) {
                continue;
            }
            j++;
            res.push(positions[i]);
        }
        return res;
    }

    getTime(dis, speed) {
        var time = dis / speed;
        return time < 0.01 ? 0.01 : time;
    }

    //计算总长(米)
    getLength(positions) {
        if (!Cesium.defined(positions) || positions.length < 2) return 0;

        var distance = 0;
        for (var i = 1, len = positions.length; i < len; i++) {
            distance += Cesium.Cartesian3.distance(positions[i - 1], positions[i]);
        }
        return distance;
    }

    getInterMeter() {
        var m_s = this.speed * 0.2777777777777778; //米每秒
        return this.allLen <= m_s ? this.allLen / 2 : m_s;
    }
    //插值线路
    interPolyline(opts) {
        var positions = opts.positions;
        var flatPositions = Cesium.PolylinePipeline.generateArc({
            positions: positions,
            height: opts.height, //未传入时，内部默认为0
            minDistance: opts.minDistance, //插值间隔(米)，优先级高于granularity
        });

        var arr = [];
        for (var i = 0; i < flatPositions.length; i += 3) {
            var position = Cesium.Cartesian3.unpack(flatPositions, i);
            arr.push(position);
        }
        return arr;
    }

    //创建运动属性
    createPositionProperty() {
        var property = new Cesium.SampledPositionProperty(); //位置属性
        var startTime = viewer.clock.currentTime; //飞行开始时间
        var stopTime; //飞行结束时间 
        var positionsArc = this.positionsArc;
        var length = positionsArc.length;//100
        var sumTime = 0;
        for (var i = 0; i < length; i++) {
            var item = positionsArc[i];
            //起点
            if (i === 0) {
                property.addSample(startTime, item);
            }
            else {
                var pre = positionsArc[i - 1];
                var dis = this.getLength([pre, item]);
                var time = this.getTime(dis, this.speed_m);
                sumTime += time;
                var sTime = Cesium.JulianDate.addSeconds(startTime, sumTime, new Cesium.JulianDate());
                property.addSample(sTime, item);
            }
        }

        var keepAng = 0.1; //为了运动到最后保持角度
        var endTime = Cesium.JulianDate.addSeconds(startTime, sumTime - keepAng, new Cesium.JulianDate());
        var pointEnd = positionsArc[length - 1];
        //为了保证到结束时间了，一直停留在那，所以加个很远的时间
        stopTime = Cesium.JulianDate.addDays(endTime, 365, new Cesium.JulianDate());
        //stopTime = Cesium.JulianDate.addSeconds(startTime, length * 1, new Cesium.JulianDate());
        //property.addSample(endTime, pointEnd);
        property.setInterpolationOptions({
            interpolationDegree: 2,
            interpolationAlgorithm: Cesium.LagrangePolynomialApproximation// //Cesium.LagrangePolynomialApproximation //HermitePolynomialApproximation
        });

        //修正一下
        endTime = Cesium.JulianDate.addSeconds(endTime, this.delay, new Cesium.JulianDate());
        this.endTime = endTime;
        if (!this.cycle) {
            property.addSample(stopTime, pointEnd);
            this.startTime = startTime;
            this.stopTime = stopTime;
            return property;
        }
        this.startTime = startTime;
        this.stopTime = endTime;
        return property;
    }


    //开始漫游
    start() {
        if (this._isStart) {
            return;
        }

        //备份
        this._bak_multiplier = this.viewer.clock.multiplier;
        this._bak_clockRange = this.viewer.clock.clockRange;
        this._bak_startTime = this.viewer.clock.startTime;
        this._bak_stopTime = this.viewer.clock.stopTime;

        //this.setSurface(this.surface);

        var positionProperty = this.createPositionProperty()
        this.entity.position = positionProperty;
        let availability = new Cesium.TimeIntervalCollection([
            new Cesium.TimeInterval({
                start: this.startTime,
                stop: this.stopTime,
            }),
        ]);
        this.entity.availability = availability;
        this.entity.orientation = new Cesium.VelocityOrientationProperty(positionProperty);
        // this.entity.path = {
        //     resolution: 1,
        //     material: new Cesium.PolylineGlowMaterialProperty({
        //         glowPower: 0.1,
        //         color: Cesium.Color.YELLOW,
        //     }),
        //     width: 10,
        // };

        // var orientation = new Cesium.VelocityOrientationProperty(this.entity.position);
        // this.entity.orientation = orientation;

        // var cylinder = this.createcylinder(positionProperty, this.height);

        // viewer.entities.add(cylinder);
        // this.cylinder = cylinder;



        viewer.clock.multiplier = this.multiple; //飞行速度 
        viewer.clock.startTime = this.startTime.clone();
        viewer.clock.currentTime = this.startTime.clone();
        viewer.clock.stopTime = this.stopTime.clone();
        viewer.clock.clockRange = Cesium.ClockRange.CLAMPED;
        // viewer.clock.onTick.addEventListener((clock) => {
        //     this.onTickCallback(clock);
        // });

        this.doShading(positionProperty);
        this.doCycle();
        this.viewer.scene.preRender.addEventListener(this.preRender_eventHandler, this);
        viewer.clock.shouldAnimate = true;
        this._isStart = true;
    }
    //暂停漫游
    pause() {
        this.viewer.clock.shouldAnimate = false;
    }
    //继续漫游
    proceed() {
        this.viewer.clock.shouldAnimate = true;
    }
    //结束漫游
    stop() {
        this.viewer.trackedEntity = undefined;
        this.viewer.scene.preRender.removeEventListener(this.preRender_eventHandler, this);
        if (this.entity) {
            this.viewer.entities.remove(this.entity);
            delete this.entity;
        }
        if (this.shading) {
            this.viewer.entities.remove(this.shading);
            delete this.shading;
        }

        if (this._bak_startTime) {
            this.viewer.clock.startTime = this._bak_startTime;
            delete this._bak_startTime;
        }
        if (this._bak_stopTime) {
            this.viewer.clock.stopTime = this._bak_stopTime;
            delete this._bak_stopTime;
        }
        if (this._bak_multiplier) {
            this.viewer.clock.multiplier = this._bak_multiplier;
            delete this._bak_multiplier;
        }
        if (this._bak_clockRange) {
            this.viewer.clock.clockRange = this._bak_clockRange;
            delete this._bak_clockRange;
        }
        this._isStart = false;

    }
    preRender_eventHandler(e) {
        if (!this._isStart || !this.viewer.clock.shouldAnimate || this.entity == null) return;
        if (Cesium.JulianDate.greaterThanOrEquals(this.viewer.clock.currentTime, this.endTime)) {
            this.viewer.trackedEntity = undefined;
            this.viewer.scene.preRender.removeEventListener(this.preRender_eventHandler, this);
            var result = this.entity.position.getValue(this.viewer.clock.currentTime);
            this.entity.position = result;
            this.endBack && this.endBack();//回调
            console.log("漫游结束");
            return;
        }

        this.doCameraType();
        this.computeOrientation();
    }
    computeOrientation() {

        if (this.entity && this.entity['billboard'] && this.entity['billboard']['rotation']) {

            var time = this.viewer.clock.currentTime;
            var position = Cesium.Property.getValueOrUndefined(this.entity.position, time, positionScratch);
            if (!Cesium.defined(position)) {
                return undefined;
            }

            //垂直屏幕为z，从屏幕自左到右为x，从屏幕自下而上为y----Cesium.Transforms.northEastDownToFixedFrame
            var orientation = Cesium.Property.getValueOrUndefined(this.entity.orientation, time, new Cesium.Quaternion());
            var autoHpr = this.getHeadingPitchRollByOrientation(position, orientation, this.viewer.scene.globe.ellipsoid, Cesium.Transforms.northEastDownToFixedFrame);
            //重新赋值新角度
            var headingTemp = autoHpr.heading;
            const heading = Cesium.Math.toRadians(Cesium.Math.toDegrees(headingTemp));

            this.entity['billboard']['rotation'] = heading;
            console.log("朝向计算--" + heading)
        }

    }
    onTickCallback(clock) {
        this.doCameraType()
        // if (Cesium.JulianDate.greaterThan(clock.currentTime, this.stopTime)) {
        //     this.entity.position = this.positionsArc[this.positionsArc.length - 1];
        //     //console.log(clock.currentTime);
        // }

        // var position=this.entity.position.getValue();
        // this.cylinder.position.setValue(position);

    }
    doCycle() {
        if (this.cycle) {
            viewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
        }
    }
    setSurface(val) {
        // if (val) {
        //     this.entity.model.heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
        // }
        // else {
        //     if (this.addHeight > 0) {
        //         this.entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_GROUND;
        //     }
        //     if (this.height > 0) {
        //         this.entity.model.heightReference = Cesium.HeightReference.NONE;
        //     }
        // }
    }
    setMultiplier(val) {
        if (isNaN(val)) {
            return;
        }
        if (val > 0) {
            this.multiple = val;
        }
        viewer.clock.multiplier = this.multiple; //飞行速度
    }
    doShading(positionProperty) {
        switch (this.shadingType) {
            case "wall":
                //entity = this.addWallShading(item);
                break;
            case "cylinder":
                var cylinder = this.createcylinder(positionProperty);
                viewer.entities.add(cylinder);
                this.shading = cylinder;
                break;
            case "circle":
                //entity = this.addCircleShading(item);
                break;
            case "polyline":
            case "polyline-going":
                //entity = this.addPolylineShading(item);
                break;
            default:
                break;
        }
    }
    setCameraType(cameraType) {
        this.cameraType = cameraType;
    }
    //处理相机视角
    doCameraType() {
        switch (this.cameraType) {//视角处理
            default:
                //无 
                if (this.viewer.trackedEntity != undefined) {
                    this.viewer.trackedEntity = undefined;
                }
                viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
                break;
            case "gs":
                //跟随视角
                if (this.viewer.trackedEntity != this.entity) {
                    this.viewer.trackedEntity = this.entity;
                }
                break;
            case "dy":
                //锁定第一视角
                this.adjust()
                ///////////////
                // if (this.viewer.trackedEntity != this.entity) this.viewer.trackedEntity = this.entity;

                // var matrix = this.getModelMatrix();

                // var transformX = 0; //距离运动点的距离（后方） 
                // var transformZ = 1; //距离运动点的高度（上方）
                // this.viewer.scene.camera.lookAtTransform(matrix, new Cesium.Cartesian3(-transformX, 0, transformZ));

                break;
            case "sd":
                //锁定上帝视角
                if (this.viewer.trackedEntity != this.entity) this.viewer.trackedEntity = this.entity;

                var matrix = this.getModelMatrix();

                var transformZ = 500; //距离运动点的高度（上方）
                this.viewer.scene.camera.lookAtTransform(matrix, new Cesium.Cartesian3(-1, 0, transformZ));
                break;
        }
    }

    // 实时调整位置
    adjust() {

        if (viewer.clock.shouldAnimate === true) {

            // 获取偏向角
            // let ori = orientation.getValue(viewer.clock.currentTime);

            // // 获取位置
            let center = this.entity.position.getValue(viewer.clock.currentTime);

            // // 1、由四元数计算三维旋转矩阵
            // var mtx3 = Cesium.Matrix3.fromQuaternion(ori);

            // 2、计算四维转换矩阵：
            var mtx4 = this.getModelMatrix();// Cesium.Matrix4.fromRotationTranslation(mtx3, center);
            // 3、计算角度：
            var hpr = Cesium.Transforms.fixedFrameToHeadingPitchRoll(mtx4);

            // 获取角度（弧度）
            const headingTemp = hpr.heading;
            const pitchTemp = hpr.pitch;

            // 调整角度为第一人称，注意调整的角度
            const heading = Cesium.Math.toRadians(Cesium.Math.toDegrees(headingTemp) + 90);
            const pitch = Cesium.Math.toRadians(Cesium.Math.toDegrees(pitchTemp) - 12);

            // 视角高度，根据模型大小调整
            const range = 140.0;

            // 动态改变模型视角
            viewer.camera.lookAt(center, new Cesium.HeadingPitchRange(heading, pitch, range));
        }
    }

    // 根据模型的orientation求方位角
    getHeadingPitchRollByOrientation(position, orientation, ellipsoid, fixedFrameTransform) {
        if (!Cesium.defined(orientation) || !Cesium.defined(position)) return new Cesium.HeadingPitchRoll();

        var matrix = Cesium.Matrix4.fromRotationTranslation(Cesium.Matrix3.fromQuaternion(orientation, matrix3Scratch), position, matrix4Scratch);
        var hpr = this.getHeadingPitchRollByMatrix(matrix, ellipsoid, fixedFrameTransform);
        return hpr;
    }

    // 根据模型的matrix矩阵求方位角 
    getHeadingPitchRollByMatrix(matrix, ellipsoid, fixedFrameTransform, result) {
        return Cesium.Transforms.fixedFrameToHeadingPitchRoll(matrix, ellipsoid, fixedFrameTransform, result);
    }
    getModelMatrix() {
        var entity = this.entity;
        var time = this.viewer.clock.currentTime;

        var position = Cesium.Property.getValueOrUndefined(entity.position, time, positionScratch);
        if (!Cesium.defined(position)) {
            return undefined;
        }
        var result;
        var orientation = Cesium.Property.getValueOrUndefined(entity.orientation, time, orientationScratch);
        if (!Cesium.defined(orientation)) {
            result = this._fixedFrameTransform(position, undefined, matrix4);
        } else {
            result = Cesium.Matrix4.fromRotationTranslation(Cesium.Matrix3.fromQuaternion(orientation, matrix3Scratch), position, matrix4);
        }
        return result;
    }
    /////
    createcylinder(property) {
        if (this.surface) {
            return;
        }
        var sumHeight = this.height + this.addHeight;
        if (sumHeight <= 0) {
            return;
        }

        var that = this;
        var heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
        // if (that.addHeight > 0 && that.height <= 0) {
        //     //position = that.calcGlobePoint(position);
        //     heightReference = Cesium.HeightReference.RELATIVE_TO_GROUND;
        // }

        var material = new Cesium.RadarRadiationWaveMaterialProperty(
            {
                color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                repeat: 15,
                offset: 0,
                thickness: 0.3,
                duration: 3000,
            });

        var bottomRadiusNow = 100;
        var lengthNow = 100;
        // 圆锥
        const entity = new Cesium.Entity({
            position: new Cesium.CallbackProperty(function (time) {
                var position = Cesium.Property.getValueOrUndefined(property, time, new Cesium.Cartesian3());
                var car = Cesium.Cartographic.fromCartesian(position);
                var heightTerrain = viewer.scene.globe.getHeight(car);
                var newPoint = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, (car.height) / 2);
                // if (that.addHeight > 0 && that.height <= 0) {
                //     newPoint = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, 0);
                // }
                lengthNow = car.height - heightTerrain;
                bottomRadiusNow = lengthNow * 0.3; //地面圆半径

                return newPoint;
            }, false),
            cylinder: {
                length: new Cesium.CallbackProperty(function (time) {
                    return lengthNow;
                }, false), //圆锥高度
                topRadius: 0.0, //顶部半径
                bottomRadius: new Cesium.CallbackProperty(function (time) {
                    return bottomRadiusNow;
                }, false), //底部半径
                heightReference: heightReference,
                material: material, //
            },
        });

        return entity;
    }
    calcGlobePoint(position) {
        var height = this.addHeight;
        var carto = Cesium.Cartographic.fromCartesian(position);
        var heightTerrain = this.viewer.scene.globe.getHeight(carto);
        var point = Cesium.Cartesian3.fromRadians(carto.longitude, carto.latitude, heightTerrain + height);
        return point;
    }
}

export default PathAnimation;